import { Injectable } from '@angular/core';

@Injectable()
export class IdentificationTypeListService {

    constructor() { }

    getList() {
        return [{ name: 'Cédula de ciudadanía', value: 'C' }];
    }

}



// WEBPACK FOOTER //
// ./src/app/bdb-identity-number/services/identification-type-list.service.ts